import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import * as HiIcons from "react-icons/hi";

const Footer = ({ isContact }: any) => {
  return (
    <motion.div
      className="footer"
      initial={{ opacity: 0, z: 100 }}
      animate={{ opacity: 1, z: 0 }}
      exit={{ opacity: 0, z: -100 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      {!isContact && (
        <>
          <div className="footer-top">
            <div className="footer-top-left">
              <motion.p
                initial={{
                  opacity: 0.75,
                  clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
                }}
                whileInView={{
                  opacity: 1,
                  clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
                }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                Ready to get started?
              </motion.p>
            </div>
            <div className="footer-top-right"></div>
          </div>
          <motion.div
            className="footer-btn-container"
            initial={{
              opacity: 0,
              transform: "scale(1.01)",
            }}
            whileInView={{
              opacity: 1,
              transform: "scale(1.02)",
            }}
            transition={{ duration: 0.25, delay: 0.5 }}
          >
            <Link className="intro-btn" to="/contact">
              <p>
                Get in touch
                <span>
                  <HiIcons.HiOutlineArrowNarrowRight />
                </span>
              </p>
            </Link>
          </motion.div>
        </>
      )}
      <motion.div
        className={isContact ? "footer-content secondary" : "footer-content"}
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <p className={isContact ? "secondary" : "footer-text"}>
          <span>©</span>
          2022
        </p>
        <Link
          className={isContact ? "secondary" : "footer-text"}
          to="/privacy-policy"
        >
          Privacy Policy
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default Footer;
